import * as React from 'react';
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { ApplicationState } from '../store';
import { useSelector } from 'react-redux';
import * as AuthStatus from '../store/TeamsState';
import { IPublicClientApplication } from '@azure/msal-browser';
import { Button, makeStyles, shorthands } from '@fluentui/react-components';

function handleLogin(instance: IPublicClientApplication) {
    instance.loginRedirect(loginRequest).catch(e => {
        console.log(e);
    });
}

const useStyles = makeStyles({
    root: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        ...shorthands.gap("20px"),
    },
});

export const SignInTab = () => {
    const authStatus: AuthStatus.TeamsState | undefined = useSelector<ApplicationState, AuthStatus.TeamsState | undefined>((state: ApplicationState) => state.teamsState);
    const { instance } = useMsal();
    const styles = useStyles();

    if (authStatus === undefined || authStatus.InTeams === null) {
        return null;
    }

    return (
        <div className={styles.root}>
            <h1>Neomytic</h1>
            <Button onClick={() => handleLogin(instance)}>Sign in</Button>
        </div>
    );
};